import React from 'react';
import HeaderTeam from '../HeaderTeam/Header';
import styles from './TeamLayout.module.css';

/**
 * Layout for team-member pages (/team-order, /edit-team-order).
 * Same content area as the seller Layout, but with the team header and no
 * sidebar, because team members only get the order pages.
 */
function TeamLayout({ children }) {
    return (
        <div className={styles.layout}>
            <HeaderTeam />
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default TeamLayout;
